import { render, staticRenderFns } from "./BigPowerLegends.vue?vue&type=template&id=89e069b2&scoped=true"
import script from "./BigPowerLegends.vue?vue&type=script&lang=js"
export * from "./BigPowerLegends.vue?vue&type=script&lang=js"
import style0 from "./BigPowerLegends.vue?vue&type=style&index=0&id=89e069b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e069b2",
  null
  
)

export default component.exports